/**
 * @file ShopDashboardMetrics.tsx
 * @description Плитки показателей «Сводки» с переключателем периода
 * (phase19.31, разбор A макет (г); SC47).
 *
 * Четыре плитки: «Выручка», «Заказы», «Средний чек», «Возвраты». Прежние
 * «Выручка 7 дней», «GMV 30 дней» и «Всего за 30 дней» повторяли друг друга —
 * их заменил один переключатель периода (пилюли «7 дней / 30 дней»). На
 * телефоне плитки 2×2, суммы без копеек — помещаются на 360.
 */

import { dashboardMetrics, DASHBOARD_PERIODS, parseDashboardPeriod, periodLabel, type DashboardPeriod } from "./dashboard-model";
import { FilterChips } from "../ui/FilterChips";
import { ListError } from "../ui/ListStates";
import { MetricTile, MetricTileSkeleton } from "../ui/MetricTile";
import type { OrderStatsDto } from "../../lib/api-orders";

interface Props {
  stats: OrderStatsDto | null;
  period: DashboardPeriod;
  /** Период, за который посчитаны показанные числа. */
  statsPeriod: DashboardPeriod;
  onPeriodChange: (days: DashboardPeriod) => void;
  loading: boolean;
  error: boolean;
  onRetry: () => void;
}

const PERIOD_CHIPS = DASHBOARD_PERIODS.map((days) => ({ value: String(days), label: periodLabel(days) }));

export function ShopDashboardMetrics({ stats, period, statsPeriod, onPeriodChange, loading, error, onRetry }: Props) {
  return (
    <section aria-label="Показатели" aria-busy={loading || undefined} className="flex flex-col gap-3">
      <FilterChips
        aria-label="Период показателей"
        items={PERIOD_CHIPS}
        value={String(period)}
        onChange={(value) => onPeriodChange(parseDashboardPeriod(value))}
      />
      {error && !stats ? (
        <ListError message="Не удалось загрузить показатели. Проверьте связь и попробуйте ещё раз" onRetry={onRetry} />
      ) : (
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
          {/* Заготовки — только пока чисел нет: смена периода не схлопывает плитки. */}
          {stats
            ? dashboardMetrics(stats, statsPeriod).map((m) => <MetricTile key={m.key} label={m.label} value={m.value} hint={m.hint} />)
            : [0, 1, 2, 3].map((i) => <MetricTileSkeleton key={i} />)}
        </div>
      )}
    </section>
  );
}
